import { Result } from "antd";
import styled from "styled-components";

export const TOBPBack = styled.p`
  margin-bottom: 1em;
  font-weight: 600;
  font-size: 16px;
  color: var(--dark);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  svg {
    font-size: 20px;
  }
`;

export const BinComplete = styled(Result)`
  width: 100%;
  min-height: 70vh;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;
